import React, { useEffect, useState } from "react";
import { withRouter, useRouteMatch } from "react-router";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// image
import SearchIcon from "../../Assets/search.svg";

// -- redux
import { connect } from "react-redux";
import { GetTheme } from "../../Redux/Actions/UserAction";

import HeaderStyle from "./style";
import RightSidebar from "../RightSidebar";
import Filter from "../Filter";
import Upload from "../Upload";
import Export from "../Export";

function Header(props) {
	const match = useRouteMatch();
	const [Search, SetSearch] = useState("");
	const [Open, SetOpen] = useState(false);
	const [userItem, setUserItem] = useState("");
	const [status, setStatus] = useState("");
	const [clear, setClear] = useState("");

	const Four = [
		{
			id: 3,
			name: "User - Business",
			type: "user",
			checked: false,
		},
		{
			id: 2,
			name: "User - Personal Banking",
			type: "user",
			checked: false,
		},
		{ id: 5, name: "User - V1be User", type: "user", checked: false },
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	];

	const two = [
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	];

	const [FilterArray, setFilterArray] = useState([
		{
			id: 3,
			name: "User - Business",
			type: "user",
			checked: false,
		},
		{
			id: 2,
			name: "User - Personal Banking",
			type: "user",
			checked: false,
		},
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [BankFilterArray, setBankFilterArray] = useState([
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [HomeFilterArray, setHomeFilterArray] = useState([
		{
			id: 3,
			name: "User - Business",
			type: "user",
			checked: false,
		},
		{
			id: 2,
			name: "User - Personal Banking",
			type: "user",
			checked: false,
		},
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [ThemeFilterArray, setThemeFilterArray] = useState([
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [ProductFilterArray, setProductFilterArray] = useState([
		{
			id: 3,
			name: "User - Business",
			type: "user",
			checked: false,
		},
		{
			id: 2,
			name: "User - Personal Banking",
			type: "user",
			checked: false,
		},
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [ZipFilterArray, setZipFilterArray] = useState([
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [VideosFilterArray, setVideosFilterArray] = useState([
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [ServicesFilterArray, setServicesFilterArray] = useState([
		{
			id: 3,
			name: "User - Business",
			type: "user",
			checked: false,
		},
		{
			id: 2,
			name: "User - Personal Banking",
			type: "user",
			checked: false,
		},
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [SettingsFilterArray, setSettingsFilterArray] = useState([
		{
			id: 3,
			name: "User - Business",
			type: "user",
			checked: false,
		},
		{
			id: 2,
			name: "User - Personal Banking",
			type: "user",
			checked: false,
		},
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const [QuestionsFilterArray, setQuestionsFilterArray] = useState([
		{
			id: 1,
			name: "Status - Enabled",
			type: "Status",
			checked: false,
		},
		{
			id: 0,
			name: "Status - Disabled",
			type: "Status",
			checked: false,
		},
	]);

	const handleResponse = (e) => {
		if (e.type === 200) {
			e && toast.success(e.message);
		} else {
			e && toast.error(e.message);
		}
	};

	const handleChecked = (id) => {
		SetSearch("");
		props.search("");
		if (props.location.pathname === "/dashboard/home") {
			if (id !== "cancel") {
				const sortCards = [...HomeFilterArray];
				const targetIndex = HomeFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setHomeFilterArray(sortCards);
			} else {
				setHomeFilterArray(Four);
			}
		} else if (props.location.pathname === "/dashboard/users") {
			if (id !== "cancel") {
				const sortCards = [...FilterArray];
				const targetIndex = FilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setFilterArray(sortCards);
			} else {
				setFilterArray(Four);
			}
		} else if (props.location.pathname === "/dashboard/banks") {
			if (id !== "cancel") {
				const sortCards = [...BankFilterArray];
				const targetIndex = BankFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setBankFilterArray(sortCards);
			} else {
				setBankFilterArray(two);
			}
		} else if (props.location.pathname === "/dashboard/themes") {
			if (id !== "cancel") {
				const sortCards = [...ThemeFilterArray];
				const targetIndex = ThemeFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setThemeFilterArray(sortCards);
			} else {
				setThemeFilterArray(two);
			}
		} else if (props.location.pathname === "/dashboard/product") {
			if (id !== "cancel") {
				const sortCards = [...ProductFilterArray];
				const targetIndex = ProductFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setProductFilterArray(sortCards);
			} else {
				setProductFilterArray(Four);
			}
		} else if (props.location.pathname === "/dashboard/zipcodes") {
			if (id !== "cancel") {
				const sortCards = [...ZipFilterArray];
				const targetIndex = ZipFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setZipFilterArray(sortCards);
			} else {
				setZipFilterArray(two);
			}
		} else if (props.location.pathname === "/dashboard/videos") {
			if (id !== "cancel") {
				const sortCards = [...VideosFilterArray];
				const targetIndex = VideosFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setVideosFilterArray(sortCards);
			} else {
				setVideosFilterArray(two);
			}
		} else if (props.location.pathname === "/dashboard/services") {
			if (id !== "cancel") {
				const sortCards = [...ServicesFilterArray];
				const targetIndex = ServicesFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setServicesFilterArray(sortCards);
			} else {
				setServicesFilterArray(Four);
			}
		} else if (props.location.pathname === "/dashboard/settings") {
			if (id !== "cancel") {
				const sortCards = [...SettingsFilterArray];
				const targetIndex = SettingsFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setSettingsFilterArray(sortCards);
			} else {
				setSettingsFilterArray(Four);
			}
		} else if (props.location.pathname === "/dashboard/questions") {
			if (id !== "cancel") {
				const sortCards = [...QuestionsFilterArray];
				const targetIndex = QuestionsFilterArray.findIndex((f) => f.id === id);
				sortCards[targetIndex].checked = !sortCards[targetIndex].checked;
				setQuestionsFilterArray(sortCards);
			} else {
				setQuestionsFilterArray(two);
			}
		}
	};

	const head = () => {
		switch (props.location.pathname) {
			case "/dashboard/home":
				return "Home Listing";
			case "/dashboard/product":
				return "Products";
			case "/dashboard/themes":
				return "Themes";
			case "/dashboard/users":
				return "Users";
			case "/dashboard/zipcodes":
				return "Zipcodes";
			case "/dashboard/videos":
				return "Videos";
			case "/dashboard/contact-us":
				return "Contact Us";
			case "/dashboard/help":
				return "Help";
			case "/dashboard/services":
				return "Services";
			case "/dashboard/questions":
				return "Questions";
			case "/dashboard/service-request":
				return "Service Requests";
			case "/dashboard/settings":
				return "Settings";
			case "/dashboard/admin":
				return "Admins";
			case "/dashboard/mobile-configuration":
				return "Mobile Configuration";
			case "/dashboard/signup":
				return "Sign Up Link";
			case "/dashboard/change-password":
				return "Change Password";
			case "/dashboard/banks":
				return "Banks";
			case "/dashboard/holidays":
				return "Holidays";
			case "/dashboard/announcements":
				return "Announcements";
			default:
				return "";
		}
	};

	const filter = () => {
		switch (props.location.pathname) {
			case "/dashboard/home":
				return HomeFilterArray;
			case "/dashboard/users":
				return FilterArray;
			case "/dashboard/banks":
				return BankFilterArray;
			case "/dashboard/themes":
				return ThemeFilterArray;
			case "/dashboard/product":
				return ProductFilterArray;
			case "/dashboard/zipcodes":
				return ZipFilterArray;
			case "/dashboard/videos":
				return VideosFilterArray;
			case "/dashboard/services":
				return ServicesFilterArray;
			case "/dashboard/settings":
				return SettingsFilterArray;
			case "/dashboard/questions":
				return QuestionsFilterArray;
		}
	};

	const link = () => {
		switch (props.location.pathname) {
			case `${match.path}/themes`:
				return `${match.path}/themes/add-theme`;
			case `${match.path}/services`:
				return `${match.path}/services/add-services`;
			case `${match.path}/questions`:
				return `${match.path}/questions/add-questions`;
			case `${match.path}/admin`:
				return `${match.path}/admin/add-admin`;
			case `${match.path}/settings`:
				return `${match.path}/settings/add-services`;
			case `${match.path}/help`:
				return `${match.path}/help/add-help`;
			case `${match.path}/contact-us`:
				return `${match.path}/help/add-contact`;
		}
	};

	const handleSearch = (e) => {
		SetSearch(e.target.value);
		props.search(e.target.value);
	};

	useEffect(() => {
		props.userSelected(userItem);
		props.statusSelected(status);
	});

	useEffect(() => {
		props.GetTheme();
	}, []);

	useEffect(() => {
		setHomeFilterArray(Four);
		setThemeFilterArray(two);
		setFilterArray(Four);
		setProductFilterArray(Four);
		setZipFilterArray(two);
		setVideosFilterArray(two);
		setServicesFilterArray(Four);
		setSettingsFilterArray(Four);
		setQuestionsFilterArray(two);
		setBankFilterArray(two);
		SetSearch("");
		props.search("");
	}, [props.clear]);

	const clearFilter = () => {
		setClear("clear");
		setTimeout(function () {
			setClear("");
		}, 100);
		setHomeFilterArray(Four);
		setThemeFilterArray(two);
		setFilterArray(Four);
		setProductFilterArray(Four);
		setZipFilterArray(two);
		setVideosFilterArray(two);
		setServicesFilterArray(Four);
		setSettingsFilterArray(Four);
		setQuestionsFilterArray(two);
		setBankFilterArray(two);
	};

	const showTotalRecordLabelsIf = () => {
		return (
			props.location.pathname !== "/dashboard/change-password" &&
			props.location.pathname !== "/dashboard/mobile-configuration" &&
			props.location.pathname !== "/dashboard/signup" &&
			props.location.pathname !== "/dashboard/service-request" &&
			props.location.pathname !== "/dashboard/holidays" &&
			props.location.pathname !== "/dashboard/announcements"
		);
	};

	const getEnabledLabel = (path) => {
		switch (path) {
			case "/dashboard/contact-us":
				return "Active:";
			case "/dashboard/questions":
				return "Active:";
			case "/dashboard/admin":
				return "Active:";
			case "/dashboard/services":
				return "Active:";
			case "/dashboard/settings":
				return "Active:";
			case "/dashboard/banks":
				return "Active:";
			default:
				return "Enabled:";
		}
	};

	const getDisabledLabel = (path) => {
		switch (path) {
			case "/dashboard/contact-us":
				return "Inactive:";
			case "/dashboard/questions":
				return "Inactive:";
			case "/dashboard/admin":
				return "Inactive:";
			case "/dashboard/services":
				return "Inactive:";
			case "/dashboard/settings":
				return "Inactive:";
			case "/dashboard/banks":
				return "Inactive:";
			default:
				return "Disabled:";
		}
	};

	const showSearch = () => {
		return (
			props.location.pathname !== "/dashboard/change-password" &&
			props.location.pathname !== "/dashboard/mobile-configuration" &&
			props.location.pathname !== "/dashboard/signup"
		);
	};

	const showSearchFilters = () => {
		const show =
			props.location.pathname !== "/dashboard/help" &&
			props.location.pathname !== "/dashboard/contact-us" &&
			props.location.pathname !== "/dashboard/admin" &&
			props.location.pathname !== "/dashboard/service-request" &&
			props.location.pathname !== "/dashboard/signup" &&
			props.location.pathname !== "/dashboard/holidays" &&
			props.location.pathname !== "/dashboard/announcements";
		return show;
	};

	const showRightSideBarForm = () => {
		return (
			props.location.pathname !== "/dashboard/themes" &&
			props.location.pathname !== "/dashboard/services" &&
			props.location.pathname !== "/dashboard/questions" &&
			props.location.pathname !== "/dashboard/settings" &&
			props.location.pathname !== "/dashboard/admin" &&
			props.location.pathname !== "/dashboard/service-request" &&
			props.location.pathname !== "/dashboard/help"
		);
	};

	const showFullScreenForm = () => {
		return (
			(props.location.pathname === "/dashboard/themes" ||
				props.location.pathname === "/dashboard/services" ||
				props.location.pathname === "/dashboard/settings" ||
				props.location.pathname === "/dashboard/questions" ||
				props.location.pathname === "/dashboard/help" ||
				props.location.pathname === "/dashboard/admin") &&
			props.location.pathname !== "/dashboard/service-request" &&
			props.location.pathname !== "/dashboard/contact-us"
		);
	};
	return (
		<>
			{props.location.pathname !== "/dashboard/reconciliations/safe-deposits" &&
				props.location.pathname !== "/dashboard/reconciliations/smart-safe" &&
				props.location.pathname !== "/dashboard/safes" && (
					<>
						<div className="header-wrap d-flex justify-content-between align-items-center m-4">
							<div className="stats-wrap">
								<h2 className="heading text-white">
									{head()}
									{showTotalRecordLabelsIf() && (
										<span className="ml-2">
											({props.enabled + props.disabled})
										</span>
									)}
								</h2>
								{showTotalRecordLabelsIf() && (
									<div className="d-flex">
										<p className="text-green">
											{getEnabledLabel(props.location.pathname)}{" "}
											<span className="ml-1 mr-2">{props.enabled}</span>
										</p>
										<p className="text-red">
											{getDisabledLabel(props.location.pathname)}
											<span className="ml-1">{props.disabled}</span>
										</p>
									</div>
								)}
								{props.location.pathname === "/dashboard/service-request" && (
									<div className="d-flex">
										<p className="text-white">
											Total:<span className="ml-1 mr-2">{props.total}</span>
										</p>
									</div>
								)}
							</div>
							{showSearch() && (
								<div className="d-flex">
									<input
										type="text"
										placeholder="Search..."
										className="search-bar"
										style={{ backgroundImage: `url(${SearchIcon})` }}
										onChange={(e) => {
											handleSearch(e);
											clearFilter();
										}}
										value={Search}
									/>
									{showSearchFilters() && (
										<Filter
											state={filter()}
											onClick={handleChecked}
											userSelected={(item) =>
												props.clear === "clear"
													? setUserItem("")
													: setUserItem(item)
											}
											statusSelected={(item) =>
												props.clear === "clear"
													? setStatus("")
													: setStatus(item)
											}
											clear={props.clear || clear}
										/>
									)}
									{props.location.pathname === "/dashboard/service-request" && (
										<Export export={(e) => props.Export(e)} />
									)}
									{props.location.pathname === "/dashboard/zipcodes" && (
										<Upload
											Upload={(e, fileInfo) => props.Upload(e, fileInfo)}
										/>
									)}
									{props.location.pathname === "/dashboard/questions" && (
										<Upload
											Upload={(e, fileInfo) => props.Upload(e, fileInfo)}
										/>
									)}
									{showRightSideBarForm() && (
										<button
											className="green-background form-button ml-5"
											onClick={() => SetOpen(true)}
										>
											Add
										</button>
									)}
									{showFullScreenForm() && (
										<Link
											to={link()}
											className="green-background form-button ml-5 d-flex justify-content-center align-items-center"
										>
											Add
										</Link>
									)}
								</div>
							)}
							<HeaderStyle />
						</div>
						{props.theme_data && (
							<RightSidebar
								Type="Add"
								sidebar={Open}
								add={props.add}
								theme={props.theme_data.data}
								close={() => SetOpen(false)}
								response={(e) => handleResponse(e)}
							/>
						)}
						<ToastContainer closeButton={false} position="top-center" />
					</>
				)}
		</>
	);
}

const mapStateToProps = ({ GetUserReducer }) => {
	const { loading, theme_data } = GetUserReducer;
	return { loading, theme_data };
};

const mapDispatchToProps = {
	GetTheme,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
